import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { CircularProgress, Box, Typography } from "@mui/material";
import isTokenValid from "../api/isTokenValid";

export function PrivateRoute({ children }) {
  const [isValidToken, setIsValidToken] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const checkTokenValidity = async () => {
      const result = await isTokenValid();
      setIsValidToken(result);
      setLoading(false);
    };

    checkTokenValidity();
  }, [location.pathname]);

  if (loading) {
    return (
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: '#f8f9fa',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 2,
          zIndex: 9999
        }}
      >
        <CircularProgress 
          size={40} 
          sx={{ color: '#1976d2' }}
        />
        <Typography 
          variant="body1" 
          sx={{ 
            color: '#6c757d',
            fontWeight: 500 
          }}
        >
          Carregando informações
        </Typography>
      </Box>
    );
  }

  if (isValidToken) {
    return children;
  }

  return <Navigate to="/login" replace />;
}